/**
 * external links
 * @param {object} obj
 * @return {void}
 */
const handleExternalLinks = () => {

    const externalLinks = [...document.querySelectorAll('a[data-internal="false"]:not([data-looped="true"])')];

    for (let i = 0; i < externalLinks.length; i++) {
        externalLinks[i].setAttribute('target', '_blank');
        externalLinks[i].setAttribute('data-looped', 'true');
    }
};

export { handleExternalLinks };


// WEBPACK FOOTER //
// ./modules/handleExternalLinks.js